"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const Menu_1 = __importDefault(require("@mui/icons-material/Menu"));
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const react_router_1 = require("react-router");
const access_1 = require("../../../../../common/constants/access");
const appConstants_1 = require("../../../../constants/appConstants");
const strings_1 = require("../../../../constants/strings");
const companyQuery_1 = require("../../../../queries/companyQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const headerNavigation_1 = __importDefault(require("../headerNavigation"));
const useHeaderState_1 = require("./hooks/useHeaderState");
require("./style.less");
const getHeaderTitle = (pageHeader, headerName) => {
    const headerData = {
        [appConstants_1.pageHeaders.COMPANY_SETTINGS]: strings_1.pageHeadersStrings.COMPANY_SETTINGS_PAGE_HEADER({ headerName }),
        [appConstants_1.pageHeaders.TEAM_SETTINGS]: strings_1.pageHeadersStrings.TEAM_SETTINGS_PAGE_HEADER({ headerName }),
    };
    return headerData[pageHeader] || headerName;
};
const pageHeaderTabsMap = {
    '/settings': appConstants_1.pageHeaders.COMPANY_SETTINGS,
    '/team': appConstants_1.pageHeaders.TEAM_SETTINGS,
};
function getPageHeader(pathName) {
    const matchingPath = Object.keys(pageHeaderTabsMap).find(path => pathName.includes(path));
    return matchingPath ? pageHeaderTabsMap[matchingPath] : '';
}
function resetTeamState({ setTeamRequestLimit, setTeamId, setTeamName, setTeam }) {
    setTeamId('');
    setTeamName('');
    setTeamRequestLimit('');
    setTeam(null);
}
const SimpleHeader = ({ children, title }) => {
    const navigate = (0, react_router_1.useNavigate)();
    const location = (0, react_router_1.useLocation)();
    const state = (0, useHeaderState_1.useHeaderState)();
    const pageHeader = getPageHeader(globalThis.location.pathname);
    const { data: user } = (0, react_query_1.useQuery)(userQuery_1.userQuery);
    const { data: companyPropertiesData } = (0, react_query_1.useQuery)((0, companyQuery_1.companyPropertiesQuery)(user?.companyAccountId, { cardprovider: 'tsgo-cardprovider' }));
    const isAmexCardProvider = companyPropertiesData?.cardprovider === 'AMEX';
    const tabs = (0, appConstants_1.pageHeaderTabsConstants)(isAmexCardProvider)[pageHeader];
    const headerTitle = getHeaderTitle(pageHeader, state.headerName);
    const initialData = (0, react_router_1.useLoaderData)();
    const { data: hasAccess } = (0, react_query_1.useQuery)({
        ...(0, userQuery_1.getVerifyUserAccessQuery)(access_1.composites.VIEW_COMPANY_SETTINGS),
        ...(initialData && { initialData: initialData?.hasAccess }),
    });
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { className: "main-header", "data-testid": "main-header", style: { zIndex: 0 }, children: [(0, jsx_runtime_1.jsxs)(material_1.AppBar, { "ts-variant": "main-header", children: [(0, jsx_runtime_1.jsx)(material_1.Button, { "data-testid": "hamburger-btn", "ts-variant": "hamburger", onClick: () => state.openSideMenuOnMobileView(true), children: (0, jsx_runtime_1.jsx)(Menu_1.default, { style: { stroke: 'black' } }) }), (0, jsx_runtime_1.jsx)(material_1.Tooltip, { title: state.headerName, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { "data-testid": "header-overview-title", "ts-variant": "header", children: title || headerTitle }) }), children, state.headerButtons.length > 0 ? ((0, jsx_runtime_1.jsx)(material_1.Stack, { direction: "row", spacing: 1, sx: {
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            ml: 'auto',
                        }, children: state.headerButtons.map((Button, index) => ((0, jsx_runtime_1.jsx)(Button, {}, index))) })) : null, hasAccess &&
                        (appConstants_1.companyTeamsPageConstants.some(link => location.pathname.includes(link)) ? ((0, jsx_runtime_1.jsx)(Close_1.default, { style: { position: 'absolute', right: 0, cursor: 'pointer' }, onClick: () => {
                                resetTeamState({
                                    setTeamRequestLimit: state.setTeamRequestLimit,
                                    setTeamId: state.setTeamId,
                                    setTeamName: state.setTeamId,
                                    setTeam: state.setTeam,
                                });
                                void navigate('/settings/teams');
                            } })) : null)] }), (0, jsx_runtime_1.jsx)(headerNavigation_1.default, { tabs: tabs })] }));
};
exports.default = SimpleHeader;
